<template>
    <div class="video-grid">
      <VideoCard
        v-for="(video, index) in videos"
        :key="index"
        :video="video"
      />
    </div>
  </template>
  
  <script>
 import VideoCard from './VideoCard.vue';
  
  export default {
    name: "VideoGrid",
    components: { VideoCard },
    props: {
      videos: {
        type: Array,
        required: true
      }
    }
  };
  </script>
  
  <style scoped>

  .video-grid {
    display: flex;
    gap: 0px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 10px;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
  }

/* Each VideoCard root element */
.video-grid > * {
  flex: 0 0 auto;          /* prevents wrapping */
  width: 230px;            /* card width */
  scroll-snap-align: start;
}


  </style>
  